<script lang="ts">
import ListTable from '@nuxtDatakodeUtils/components/list/Table.vue'
import mapPopup from './map-popup.vue'

export default {
    name: 'MapTooltip',
    components: { ListTable },
    extends: mapPopup,
    data() {
        return {
            sheet: false,
        }
    },
}
</script>

<template>
    <v-expand-transition v-show="sheet">
        <div style="display: flex; justify-content: end">
            <v-card
                class="py-1 px-1 text-center position-absolute"
                style="bottom:0; z-index:1000; pointer-events: none"
                width="50%"
            >
                <ListTable
                    v-if="translationName"
                    ref="table"
                    :style="{ visibility: sheet ? 'visible' : 'hidden' }"
                    density="compact"
                    permission-name=""
                    :permission-skip="true"
                    :translation-name
                    :sortable="[]"
                    :no-action="true"
                    :columns
                    :data="features.map(feature => feature.getProperties())"
                />
            </v-card>
        </div>
    </v-expand-transition>
</template>

<style>
</style>
